import { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { localize } from '@saviynt/common';

/** Typesafe type for the localization function */
export type InvertedLocalize<T> = (
  defaultMessage: T,
  placeholders?: Record<string, string | number>
) => string;

/** Hook that allows localization of inverted strings from a dictionary */
export function useInvertedLocalize<T extends Record<string, string>>(
  invertedMessages: T
): InvertedLocalize<keyof T> {
  const intl = useIntl();

  return useCallback(
    (
      defaultMessage: keyof T,
      placeholders?: Record<string, string | number>
    ): string => {
      const id = invertedMessages[defaultMessage];

      return localize(
        intl,
        { id, defaultMessage: defaultMessage as string },
        placeholders
      );
    },
    [intl, invertedMessages]
  );
}
